unable to read source [project]/node_modules/.pnpm/next@14.2.30_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/src/shared/lib/image-config.ts